module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.bookingHistory) ? _c('div', {
    staticClass: "bookings"
  }, [(_vm.$breakpoints.xs) ? [_c('sk-carousel', {
    attrs: {
      "pageMarkers": ""
    }
  }, _vm._l((_vm.bookingHistory), function(booking, index) {
    return _c('div', {
      key: booking.VistaTransactionId + '-' + booking.SessionId,
      staticClass: "slide",
      attrs: {
        "slot": "slides"
      },
      slot: "slides"
    }, [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "bookings--header"
    }, [_c('h4', {
      staticClass: "movie-title"
    }, [_vm._v(" " + _vm._s(booking.Movie.title))]), _vm._v(" "), _vm._t("list", [_c('ul', {
      staticClass: "list text-bold--500"
    }, [_c('li', [_vm._v(_vm._s(booking.Movie.rating))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(booking.Movie.runtime_string))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(booking.Movie.genresString))])])]), _vm._v(" "), _c('div', {
      staticClass: "qr-code visible-xs"
    }, [_c('div', {
      staticClass: "qr-code--block"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": booking.Barcode,
        "alt": "QR Code"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "qr-code--ticket-reference"
    }, [_c('span', [_vm._v("Booking reference no " + _vm._s(booking.BookingId))])])])], 2), _vm._v(" "), _c('div', {
      staticClass: "bookings--content"
    }, [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm3": ""
      }
    }, [_c('div', {
      staticClass: "bookings-details"
    }, [_c('p', {
      staticClass: "h5 text-bold--500"
    }, [_vm._v("Tickets")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(booking.Tickets.length))])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm3": ""
      }
    }, [_c('div', {
      staticClass: "bookings-details"
    }, [_c('p', {
      staticClass: "h5 text-bold--500"
    }, [_vm._v("Cinema type")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(booking.MovieSession.experiencesString))])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm3": ""
      }
    }, [_c('div', {
      staticClass: "bookings-details"
    }, [_c('p', {
      staticClass: "h5 text-bold--500"
    }, [_vm._v("Seats")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(booking.SeatString))])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm3": ""
      }
    }, [(booking.MovieSession) ? _c('div', {
      staticClass: "bookings-details"
    }, [_c('p', {
      staticClass: "h5 text-bold--500"
    }, [_vm._v("Cinema")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(booking.MovieSession.screen_name))])]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm3": ""
      }
    }, [_c('div', {
      staticClass: "bookings-details"
    }, [_c('p', {
      staticClass: "h5 text-bold--500"
    }, [_vm._v("Where")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(booking.CinemaName.substring(0, booking.CinemaName.lastIndexOf(" "))))])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm3": ""
      }
    }, [_c('div', {
      staticClass: "bookings-details"
    }, [_c('p', {
      staticClass: "h5 text-bold--500"
    }, [_vm._v("When")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(booking.BookingDate.additional.string_long_day_of_week) + " " + _vm._s(booking.BookingDate.additional.string_nth_day) + " " + _vm._s(booking.BookingDate.additional.string_long_month))])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm3": ""
      }
    }, [_c('div', {
      staticClass: "bookings-details"
    }, [_c('p', {
      staticClass: "h5 text-bold--500"
    }, [_vm._v("What time")]), _vm._v(" "), _c('p', [_vm._v("Starts " + _vm._s(booking.BookingDate.date.format("h:mm A")) + ", Ends " + _vm._s(booking.EndDate.date.format("h:mm A")))])])]), _vm._v(" "), (booking.Concessions.length > 0) ? _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm2": ""
      }
    }, [_c('div', {
      staticClass: "bookings-details"
    }, [_c('p', {
      staticClass: "h5 text-bold--500"
    }, [_vm._v("Your extras")]), _vm._v(" "), _vm._l((booking.Concessions), function(concession) {
      return _c('p', [_vm._v(_vm._s(concession.QuantityBooked) + " x " + _vm._s(concession.Description))])
    })], 2)]) : _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm2": ""
      }
    }), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "sm1": ""
      }
    }, [(_vm.showDownload) ? _c('sk-button', {
      attrs: {
        "secondary": "",
        "loading": booking.loadingPdf
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.downloadPDF(booking.BookingId, booking.BookingNumber, booking)
        }
      }
    }, [_vm._v("Download")]) : _vm._e()], 1), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('p', [_vm._v("* This confirms your booking")]), _vm._v(" "), _c('div', {
      staticClass: "bookings-notification"
    }, [_c('p', [_vm._v("* You can collect your snacks and 3D glasses at the Online Collections Counter")])])])], 1)], 1)]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "bookings--share"
    }, [_c('sk-list', [_c('sk-list-item', [_c('sk-icon', {
      attrs: {
        "download": ""
      }
    })], 1)], 1)], 1)])], 1)], 1)
  }))] : [_c('hr'), _vm._v(" "), _vm._l((_vm.bookingHistory), function(booking, index) {
    return _c('sk-layout', {
      key: booking.VistaTransactionId + '-' + booking.SessionId,
      staticClass: "booking-history-item",
      attrs: {
        "row": "",
        "wrap": "",
        "gutter-30": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm2": ""
      }
    }, [_c('div', {
      staticClass: "bookings--movie-poster"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": booking.Movie.poster,
        "alt": ""
      }
    })])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm10": ""
      }
    }, [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "sm8": ""
      }
    }, [_c('div', {
      staticClass: "bookings--header"
    }, [_c('h4', {
      staticClass: "movie-title"
    }, [_vm._v(" " + _vm._s(booking.Movie.title))]), _vm._v(" "), _vm._t("list", [_c('ul', {
      staticClass: "list text-bold--500"
    }, [_c('li', [_vm._v(_vm._s(booking.CinemaName.substring(0, booking.CinemaName.lastIndexOf(" ")))), _c('span', {
      staticClass: "bookings--header-separate"
    }, [_vm._v("|")])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(booking.BookingDate.additional.string_long_day_of_week) + " " + _vm._s(booking.BookingDate.additional.string_nth_day) + " " + _vm._s(booking.BookingDate.additional.string_long_month)), _c('span', {
      staticClass: "bookings--header-separate"
    }, [_vm._v("|")])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(booking.BookingDate.date.format("h:mm A")) + " - " + _vm._s(booking.EndDate.date.format("h:mm A")))])])])], 2), _vm._v(" "), _c('div', {
      staticClass: "bookings--content"
    }, [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "sm12": "",
        "md6": ""
      }
    }, [_c('div', {
      staticClass: "h5"
    }, [_c('span', {
      staticClass: "text-bold--500"
    }, [_vm._v("Tickets")]), _vm._v(" "), _c('span', [_vm._v("x " + _vm._s(booking.Tickets.length))])]), _vm._v(" "), _c('div', {
      staticClass: "h5"
    }, [_c('span', {
      staticClass: "text-bold--500"
    }, [_vm._v("Seats")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(booking.SeatString))])]), _vm._v(" "), (booking.MovieSession) ? _c('div', {
      staticClass: "h5"
    }, [_c('span', {
      staticClass: "text-bold--500"
    }, [_vm._v("Cinema")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(booking.MovieSession.screen_name))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "h5"
    }, [_c('span', {
      staticClass: "text-bold--500"
    }, [_vm._v("Cinema type")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(booking.MovieSession.experiencesString))])])]), _vm._v(" "), (booking.Concessions.length > 0 && !_vm.isSingleBooking) ? _c('sk-flex', {
      staticClass: "bookings--content-extras",
      attrs: {
        "sm12": "",
        "md6": ""
      }
    }, [_c('div', {
      staticClass: "h5 text-bold--500"
    }, [_vm._v("Your extras")]), _vm._v(" "), _vm._l((booking.Concessions), function(concession) {
      return _c('div', {
        staticClass: "h5"
      }, [_vm._v(_vm._s(concession.QuantityBooked) + " x " + _vm._s(concession.Description))])
    })], 2) : _vm._e(), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    })], 1)], 1)]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "sm4": ""
      }
    }, [_c('p', {
      staticClass: "bookings__ref-title"
    }, [_vm._v("Booking Reference no:")]), _vm._v(" "), _c('p', {
      staticClass: "bookings__ref-number"
    }, [_vm._v(_vm._s(booking.BookingId))]), _vm._v(" "), _c('p', [_vm._v("If you are unable to download or print, use your booking reference number above at the Online Collections Counter to collect your tickets and snacks.")]), _vm._v(" "), _c('p', [_vm._v("Enjoy your movie!")]), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [(_vm.showView) ? _c('sk-flex', {
      attrs: {
        "xs12": "",
        "lg6": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.$breakpoints.mdDown) ? _c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('sk-spacer', {
      attrs: {
        "height": "10"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.showDownload) ? _c('sk-flex', {
      attrs: {
        "xs12": "",
        "lg6": ""
      }
    }, [_c('sk-button', {
      attrs: {
        "block": "",
        "secondary": "",
        "loading": booking.loadingPdf
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.downloadPDF(booking.BookingId, booking.BookingNumber, booking)
        }
      }
    }, [_vm._v("Download")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.bookingHistory[0].Concessions), function(concession, index) {
    return (_vm.isSingleBooking) ? _c('sk-layout', {
      key: concession.ItemId,
      staticClass: "booking-history-item",
      staticStyle: {
        "page-break-before": "always"
      },
      attrs: {
        "row": "",
        "wrap": "",
        "gutter-30": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm2": ""
      }
    }, [_c('div', {
      staticClass: "counter-box counter-box--no-backface"
    }, [_c('div', {
      staticClass: "bookings--movie-poster counter-box__icon",
      class: (concession.Description.toLowerCase().includes('large') ? 'icon--large' : '') || (concession.Description.toLowerCase().includes('small') ? 'icon--small' : '') || (concession.Description.toLowerCase().includes('voucher') ? 'icon--small' : '')
    }, [_c('sk-icon', {
      attrs: {
        "type": (concession.ItemClassCode) ? concession.ItemClassCode : '0014'
      }
    })], 1)])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm10": ""
      }
    }, [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "sm8": ""
      }
    }, [_c('div', {
      staticClass: "bookings--header"
    }, [_c('h4', {
      staticClass: "movie-title"
    }, [_vm._v(" " + _vm._s(concession.Description))])]), _vm._v(" "), _c('div', {
      staticClass: "bookings--content"
    }, [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "sm8": ""
      }
    }, [_c('div', {
      staticClass: "h5"
    }, [_c('span', {
      staticClass: "text-bold--500"
    }, [_vm._v(" " + _vm._s(concession.QuantityBooked))]), _vm._v(" "), _c('span', [_vm._v("x " + _vm._s(concession.Description))])]), _vm._v(" "), (~concession.Description.toLowerCase().indexOf('3d')) ? _c('p', [_vm._v("*You can collect your snacks and 3D glasses at the Online Collections Counter")]) : (~concession.Description.toLowerCase().indexOf('imax')) ? _c('p', [_vm._v("*You can collect your snacks and IMAX 3D glasses at the Online Collections Counter")]) : _vm._e()])], 1)], 1)]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "sm4": ""
      }
    })], 1)], 1)], 1) : _vm._e()
  })]], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94c0766c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/booking/booking.vue
// module id = 871
// module chunks = 0